const ALLOWED_CHARACTERS_REGEX = /^[a-zA-Z0-9\s.,/-]*$/;
const DECIMAL_REGEX = /^\d*\.?\d+$/;
const IMO_NUMBER_REGEX = /^[a-zA-Z0-9\s./-]*$/;
const PHONE_REGEX = /^[\d+]+$/;
const DEFAULT_OPTION_PAGE_SIZE = [5, 10, 25];
const DEFAULT_PAGE_NUMBER = 1;
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_SIZE_LONG = 25;
const DEFAULT_TIMEOUT_AXIOS = 10000;
const DURATION_TOAST = 9000;
const EMAIL_CONTACT_INSPECTION_FEE = "sire.pmsol@pertamina.com";
const FOOTER_TEXT = `© Copyright ${new Date().getFullYear()} | PT. Pertamina Marine Solutions. All Rights Reserved. `; // add a space at the end of this string
const PRIVACY_POLICY_URL = "https://pertamina-pmsol.com/page/privacy-policy";
const FORMAT_ADD_DATE = "yyyy-MM-dd";
const FORMAT_UI_DATE = "d MMM y";
const FORMAT_UI_DATE_NUMERIC = "dd-MM-y";
const FORMAT_UI_DATETIME_NUMERIC = "dd-MM-y HH:mm";
const FORMAT_UI_DATETIME_NUMERIC_SECONDS = "dd-MM-y HH:mm:ss";
const PPN_PERCENTAGE = 11;
const PROTOCOL_MAILTO = "mailto:";
const SIRE_REVIEW_TIME_WARNING = 360; // minutes
const SIRE_REVIEW_IN_PROGRESS_STATUS = "inprogress";
const MEGABYTE = 1024 * 1024;
const MAX_FILE_SIZE_1MB = 1 * MEGABYTE;
const MAX_FILE_SIZE_5MB = 5 * MEGABYTE;
const MAX_FILE_SIZE_10MB = 10 * MEGABYTE;
const MAX_FILE_SIZE_20MB = 20 * MEGABYTE;
const MAX_FILE_SIZE_30MB = 30 * MEGABYTE;
const MAX_LENGTH_CHAR = 50;
const MAX_LENGTH_CHAR_NOTE = 255;
const ROLES = {
  SUPER_ADMIN: "super admin",
  FINANCE: "admin finance",
  SHIP_OPERATOR: "ship operator",
  INSPECTING_COMPANY: "inspecting company",
  REQUESTOR: "requestor",
  // Add more roles as needed
};
const DEFAULT_COMPANY_NAME = "Pertamina";
const ACTIVE_MENU = {
  CREATE_INVOICE: "Create Invoice",
  // Add more active menu options as needed
};
const MONTHS_OPTION = [
  "All",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT_OPTION = MONTHS_OPTION.map((month) => month.slice(0, 3));
const YEAR_START = 2024;
const YEAR_START_VESSEL = 1900;
const CLIENT_ID_SETTINGS = "react-client-inspection";
const SMALL_SCREEN_WIDTH_LIMIT = 800;

const CURRENCY = {
  USD: {
    code: "USD",
    prefix: "$",
    suffix: "",
    name: "US Dollars",
  },
  IDR: {
    code: "IDR",
    prefix: "Rp ",
    suffix: "",
    name: "Rupiah",
  },
} as const;

const CURRENCY_TO_LOCALE_STRING = {
  IDR: "id-ID",
  USD: "en-US",
  EUR: "en-US",
} as const;

enum NOMINATION_STATUS {
  NEW = 0,
  APPROVED = 1,
  REJECTED = 2,
  CANCELED = 3,
}

enum INSPECTION_PROCESS {
    IN_PROGRESS = 0,
    DONE = 1,
    CANCEL = 2,
};

enum INVOICE_STATUS {
  DRAFT = 0,
  APPROVED = 1,
  IN_PROGRESS = 2,
  REJECTED = 3,
  FINANCE = 4,
}

enum PAYMENT_STATUS {
  UNPAID = 0,
  PAID = 1,
  PENDING = 2,
  REJECTED = 3,
  COMPLETED = 4,
}

enum PDF_STATUS {
  NEW = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
}

enum REGISTRATION_STATUS {
  // also USER_STATUS and VESSEL_STATUS
  INITIAL = 0,
  NEW = 1,
  IN_REVIEW = 2,
  ACTIVE = 3,
  REJECTED = 4,
  INACTIVE = 5,
}

enum UPLOAD_TYPE {
  Invoices = 0,
  InspectorInvoices = 1,
  ShipOwnerPayments = 2,
  InspectorsPayments = 3,
  InvoiceTemplates = 4,
  InvoiceTemplatesPreview = 5,
  InspectorPerson = 6,
  InspectionCompany = 7,
  ShipOperator = 8,
  Vessel = 9,
  InspectionResult = 10,
  SireReview = 11,
  Nomination = 12,
  InvoiceCompany = 13,
  GeneralSetting = 14,
  SireReviewInvoice = 15,
  RequestorInvoice = 16,
  InspectionResultUploadPDF = 17,
}

const SIRE_REVIEW_INVOICE_TYPE = {
  INSPECTOR: "inspector",
  REQUESTOR: "requestor",
} as const;

const SERVICES = {
  INSPECTION: "inspection",
  SIRE_REVIEW: "sire-review",
} as const;

const COLORS = {
  PRIMARY: "#CB1C20",
  SECONDARY: "#E84C4F",
  TERTIARY: "#FFD8D8",
  HIGHLIGHT: "#FFEEEE",
  BLUE_PRIMARY: "#1072BA",
  BLUE_DARK: "#0D5B95",
  BLUE_LIGHT: "#F3F6F9",
  GREEN_PRIMARY: "#BDD860",
  GREEN_DARK: "#99AF32",
  GREEN_LIGHT: "#F3F9DC",
  GREEN_STATUS: "#067647",
  BUTTON: {
    BACKGROUND: "#000000",
    FOREGROUND: "#FFFFFF",
  },
  TABLE_HEADER: {
    BACKGROUND: "#FFEEEE",
    BACKGROUND2: "#FFE0E0",
    FOREGROUND: "#000000",
  },
  MENU: {
    ACTIVE: "#101828",
    INACTIVE: "#98A2B3",
  },
} as const;

const REVIEW_RESULT = {
  RECOMMENDED: 0,
  NOT_RECOMMENDED: 1,
} as const;

export {
  ALLOWED_CHARACTERS_REGEX,
  DECIMAL_REGEX,
  IMO_NUMBER_REGEX,
  PHONE_REGEX,
  DEFAULT_OPTION_PAGE_SIZE,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_SIZE_LONG,
  DEFAULT_TIMEOUT_AXIOS,
  DURATION_TOAST,
  EMAIL_CONTACT_INSPECTION_FEE,
  FOOTER_TEXT,
  PRIVACY_POLICY_URL,
  FORMAT_ADD_DATE,
  FORMAT_UI_DATE,
  FORMAT_UI_DATE_NUMERIC,
  FORMAT_UI_DATETIME_NUMERIC,
  FORMAT_UI_DATETIME_NUMERIC_SECONDS,
  PPN_PERCENTAGE,
  PROTOCOL_MAILTO,
  SIRE_REVIEW_TIME_WARNING,
  SIRE_REVIEW_IN_PROGRESS_STATUS,
  MAX_FILE_SIZE_1MB,
  MAX_FILE_SIZE_5MB,
  MAX_FILE_SIZE_10MB,
  MAX_FILE_SIZE_20MB,
  MAX_FILE_SIZE_30MB,
  MAX_LENGTH_CHAR,
  MAX_LENGTH_CHAR_NOTE,
  ROLES,
  DEFAULT_COMPANY_NAME,
  ACTIVE_MENU,
  MONTHS_OPTION,
  MONTHS_SHORT_OPTION,
  YEAR_START,
  YEAR_START_VESSEL,
  CURRENCY,
  CURRENCY_TO_LOCALE_STRING,
  NOMINATION_STATUS,
  INSPECTION_PROCESS,
  INVOICE_STATUS,
  PAYMENT_STATUS,
  PDF_STATUS,
  REGISTRATION_STATUS,
  REGISTRATION_STATUS as VESSEL_STATUS,
  REGISTRATION_STATUS as USER_STATUS,
  UPLOAD_TYPE,
  SIRE_REVIEW_INVOICE_TYPE,
  CLIENT_ID_SETTINGS,
  SERVICES,
  COLORS,
  SMALL_SCREEN_WIDTH_LIMIT,
  REVIEW_RESULT,
}
